import React, { Component } from 'react';
interface Props {
  children: React.ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Page error caught by ErrorBoundary:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-[60vh] flex items-center justify-center px-4" data-id="element-1389">
          <div className="max-w-md w-full text-center p-8 border-2 border-gray-300 rounded-lg bg-white" data-id="element-1390">
            <div className="text-5xl mb-4" data-id="element-1391">⚠️</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-3" data-id="element-1392">
              Something went wrong
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1393">
              We're sorry, but this page encountered an unexpected error. Please
              try refreshing.
            </p>
            <button onClick={() => {
            this.setState({
              hasError: false,
              error: null
            });
            window.location.reload();
          }} className="px-6 py-3 bg-gray-800 text-white rounded-md font-medium hover:bg-gray-700 transition-colors" data-id="element-1394">
              Refresh Page
            </button>
            <button onClick={() => {
            this.setState({
              hasError: false,
              error: null
            });
            window.location.href = '/';
          }} className="block mx-auto mt-3 text-gray-500 hover:text-gray-700 text-sm transition-colors" data-id="element-1395">
              Go to Homepage
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}